import React from 'react';

import Link from 'common/Link';
import styles from 'css-module/components/www/_LandingFeaturesCTA.module.scss';

const LandingFeaturesCTA = () => {
  return (
    <section className={styles.landingFeaturesCTA}>
      <div className={styles.title}>
        <div className={`${styles.boltIcon} icon-bolt`}></div>Powered by some awesome features—check
        them&nbsp;out!
      </div>
      <Link to="/features" className="LandingGlobal__cta LandingGlobal__cta--outlined">
        Learn more
      </Link>
    </section>
  );
};

export default LandingFeaturesCTA;
